import { SimulateRequest, SimulationSummaryResponse } from "./types";

export async function simulate(body: SimulateRequest): Promise<SimulationSummaryResponse> {
  const simulateFunctionUrl = `${process.env.REACT_APP_API_URL}/api/SimulateFunction`;
  const res = await fetch(simulateFunctionUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`API error ${res.status}: ${text || res.statusText}`);
  }
  return res.json() as Promise<SimulationSummaryResponse>;
}